import React from "react";
import socialComposite from "../assets/Tera/social-composite-mobile.png";
import socialCompositeMobile from "../assets/Tera/social-composite-mobile.png";
import hacetucompra from "../assets/Entradas/hacetucompra.png";

const TERA_IG = "https://www.instagram.com/tera.oficial.ok";
const TICKETERA_LINK = "https://paseshow.com.ar/eventos/tera-un-millon-de-momentos-la-konga";

export default function SocialBlock({ isMobile, style }) {
  const mobile = isMobile ?? window.innerWidth <= 768;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: mobile ? "8px" : "14px",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        padding: mobile ? "0 10px" : 0,
        flexWrap: "nowrap",
        ...style,
      }}
    >
      <a
        href={TERA_IG}
        target="_blank"
        rel="noreferrer"
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          flex: mobile ? "1 1 auto" : "0 0 auto",
          minWidth: 0,
        }}
      >
        <img
          src={mobile ? socialCompositeMobile : socialComposite}
          alt="Seguinos en Instagram @tera.oficial.ok"
          style={
            mobile
              ? { height: "auto", maxHeight: "68px", width: "100%", maxWidth: "260px", objectFit: "contain" }
              : { height: "70px", width: "auto" }
          }
        />
      </a>

      <button
        onClick={() => window.open(TICKETERA_LINK, "_blank", "noopener,noreferrer")}
        style={{
          display: "flex",
          alignItems: "center",
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          flex: "0 0 auto",
        }}
      >
        <img
          src={hacetucompra}
          alt="Hacé tu compra!"
          style={{ height: mobile ? "42px" : "40px", width: "auto" }}
        />
      </button>
    </div>
  );
}
